import React, { useRef, useState } from "react";
import { Upload, Loader2, ImageIcon, Link2, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ImageUploader({ value, onChange, label, testid, optional }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [showUrl, setShowUrl] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/upload", form);
      onChange(`${BACKEND_URL}${data.url}`);
      toast.success("Imagem enviada");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Falha no envio");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="space-y-2" data-testid={testid}>
      {label && (
        <span className="font-body text-[0.62rem] text-[var(--nude)] uppercase tracking-widest">
          {label}
          {optional && (
            <span className="ml-1.5 text-[var(--muted)] normal-case tracking-normal lowercase">
              (opcional)
            </span>
          )}
        </span>
      )}
      <div className="flex items-center gap-3">
        <div className="w-16 h-16 shrink-0 border border-[rgba(212,175,55,0.3)] bg-black/40 overflow-hidden flex items-center justify-center">
          {value ? (
            <img src={value} alt="" className="w-full h-full object-cover" />
          ) : (
            <ImageIcon size={20} className="text-[var(--muted)]" strokeWidth={1.4} />
          )}
        </div>
        <div className="flex-1 flex flex-col gap-2">
          <div className="flex gap-2">
            <button
              type="button"
              data-testid={`${testid}-upload-btn`}
              onClick={() => inputRef.current?.click()}
              disabled={uploading}
              className="flex items-center gap-1.5 px-3 py-2 border border-[var(--gold)] text-[var(--gold)] hover:bg-[var(--gold)] hover:text-black transition-colors text-[0.62rem] uppercase tracking-widest font-body disabled:opacity-50"
            >
              {uploading ? (
                <Loader2 size={13} className="animate-spin" />
              ) : (
                <Upload size={13} strokeWidth={1.6} />
              )}
              {uploading ? "Enviando..." : "Enviar imagem"}
            </button>
            <button
              type="button"
              onClick={() => setShowUrl((v) => !v)}
              className="flex items-center gap-1.5 px-3 py-2 border border-[rgba(212,175,55,0.3)] text-[var(--nude)] hover:text-[var(--gold)] transition-colors text-[0.62rem] uppercase tracking-widest font-body"
            >
              <Link2 size={13} strokeWidth={1.6} /> URL
            </button>
            {value && (
              <button
                type="button"
                data-testid={`${testid}-remove-btn`}
                onClick={() => {
                  onChange("");
                  setShowUrl(false);
                }}
                className="flex items-center gap-1.5 px-3 py-2 border border-[rgba(212,175,55,0.25)] text-[var(--muted)] hover:text-red-400 hover:border-red-400/50 transition-colors text-[0.62rem] uppercase tracking-widest font-body"
              >
                <X size={13} strokeWidth={1.6} /> Remover
              </button>
            )}
          </div>
          {showUrl && (
            <input
              type="text"
              value={value || ""}
              onChange={(e) => onChange(e.target.value)}
              placeholder="https://..."
              className="w-full bg-black/40 border border-[rgba(212,175,55,0.3)] text-white px-3 py-2 text-xs focus:outline-none focus:ring-1 focus:ring-[var(--gold)]"
            />
          )}
        </div>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/png,image/jpeg,image/webp,image/gif"
        onChange={handleFile}
        className="hidden"
      />
    </div>
  );
}
